import React from "react";

const DeleteIcon = (props) => {
  return (
    <svg id="delete_black_24dp" viewBox="0 0 24 24" {...props}>
      <path
        id="Path_13062"
        data-name="Path 13062"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Path_13063"
        data-name="Path 13063"
        d="M16,9V19H8V9h8M14.5,3h-5l-1,1H5V6H19V4H15.5ZM18,7H6V19a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2Z"
        fill={props.fill || "#a5a5a5"}
      />
    </svg>
  );
};

export default DeleteIcon;
